export default __webpack_public_path__ + "static/media/backgroundmobile.230f2d1d.png";